import appStore from 'store';
import api from './api';
import LANGUAGE from 'common/languages_code';

const store = {
    namespaced: true,
    state :{
        query: {language: String(Object.keys(LANGUAGE)[0])},
        languageList: Object.keys(LANGUAGE).map(item => {
            return {
                value: String(item),
                label: LANGUAGE[item]
            };
        })
    },
    mutations:{
        changeQuery(state, payload) {
            state.query = payload;
        }
    },
    actions:{
    }
}

appStore.registerModule('cmsManage', store);
